export default "__VITE_ASSET__B7_uLIeH__"